import {
  PaymentIntegrationType,
  PaymentIntegrationUsageType,
} from "@lemmonhq/types";
import payrexxLogo from "@app/images/partner-logos/payrexx.png";
import walleeLogo from "@app/images/partner-logos/wallee.png";
import nakkaLogo from "@app/images/partner-logos/nakka.png";
import tbcbankLogo from "@app/images/partner-logos/tbcbank.svg?url";
import stripeLogo from "@app/images/partner-logos/stripe.svg?url";

const INTEGRATION_LOGOS: Partial<Record<PaymentIntegrationType, string>> = {
  payrexx: payrexxLogo,
  payrexx_softpos: payrexxLogo,
  stripe: stripeLogo,
  wallee: walleeLogo,
  nakka: nakkaLogo,
  tiblisi_bank: tbcbankLogo,
};

export const getIntegrationLogo = (type: PaymentIntegrationType): string | null =>
  INTEGRATION_LOGOS[type] ?? null;

export const getIntegrationIcon = (type: PaymentIntegrationType): string => {
  const icons: Record<PaymentIntegrationType, string> = {
    payrexx: "credit_card",
    payrexx_softpos: "phonelink",
    stripe: "credit_score",
    nakka: "payment",
    tiblisi_bank: "account_balance",
    wallee: "payment",
  };
  return icons[type] || "payment";
};

export const getIntegrationLabel = (type: PaymentIntegrationType): string => {
  const labels: Record<PaymentIntegrationType, string> = {
    payrexx: "Payrexx",
    payrexx_softpos: "Payrexx SoftPOS",
    stripe: "Stripe",
    nakka: "Nakka",
    tiblisi_bank: "Tbilisi Bank",
    wallee: "Wallee",
  };
  return labels[type] || type;
};

export const getIntegrationUsageLabel = (
  usage?: PaymentIntegrationUsageType,
): string => {
  switch (usage) {
    case "online":
      return "Online";
    case "tap2pay":
      return "Tap to Pay";
    case "terminal":
      return "Terminal";
    default:
      return "Unassigned";
  }
};

export const getIntegrationUsageIcon = (
  usage?: PaymentIntegrationUsageType,
): string => {
  switch (usage) {
    case "online":
      return "language";
    case "tap2pay":
      return "contactless";
    case "terminal":
      return "point_of_sale";
    default:
      return "help";
  }
};
